export default "__VITE_ASSET__bef66522__"